import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58be169c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58be169c')) {
      api.createRecord('58be169c', component.options)
    } else {
      api.reload('58be169c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58be169c", function () {
      api.rerender('58be169c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/supplier/index.vue"
export default component.exports